// Every admin/guest API client parses PHP responses as JSON. If the server
// ever returns something that isn't valid JSON (a stray PHP warning printed
// before the JSON, a proxy error page, an empty body on a crashed request,
// etc.), a bare `res.json()` throws — and since every caller's catch block
// only has the exception (not the response), the admin sees a generic
// "Connection error" with zero indication of what actually happened.
// Routing every response through here instead means a parse failure still
// produces a normal `{ success: false, message }` object, with the real
// HTTP status (and a snippet of the raw body, if there was one) in the
// message — so the failure is diagnosable from the UI instead of hidden
// behind a catch-all string.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function parseJsonResponse(res: Response): Promise<any> {
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch {
    const snippet = text.trim().slice(0, 200);
    return {
      success: false,
      message: snippet
        ? `Server returned an unexpected response (HTTP ${res.status}): ${snippet}`
        : `Server returned an empty response (HTTP ${res.status}).`,
    };
  }
}
